module.exports = __webpack_public_path__ + "img/cover-home.e8a14c4f.jpg";